import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react';

export interface MapOverlayContextValue {
  overlay: string | null;
  setOverlay: Dispatch<SetStateAction<string | null>>;
  createdAt: Date | undefined;
  setCreatedAt: Dispatch<SetStateAction<Date | undefined>>;
  targetCountInfo: string | null;
  setTargetCountInfo: Dispatch<SetStateAction<string | null>>;
  trigger: number;
  setTrigger: Dispatch<SetStateAction<number>>;
}

const MapOverlayContext = createContext<MapOverlayContextValue | undefined>(
  undefined,
);

export const MapOverlayProvider = ({ children }: { children: ReactNode }) => {
  const [overlay, setOverlay] = useState<string | null>(null);
  const [createdAt, setCreatedAt] = useState<Date | undefined>();
  const [targetCountInfo, setTargetCountInfo] = useState<string | null>(null);
  const [trigger, setTrigger] = useState<number>(0);

  return (
    <MapOverlayContext.Provider
      value={{
        overlay,
        setOverlay,
        createdAt,
        setCreatedAt,
        targetCountInfo,
        setTargetCountInfo,
        trigger,
        setTrigger,
      }}
    >
      {children}
    </MapOverlayContext.Provider>
  );
};

export const useMapOverlay = () => {
  const context = useContext(MapOverlayContext);
  if (!context) {
    throw new Error('useMapOverlay must be used within a MapOverlayProvider');
  }
  return context;
};
